import { __awaiter, __generator, __read } from 'tslib';
import { useContext, useCallback, useEffect } from 'react';
import { ContentfulClientConfigContext, countryCodeIndicatorFromPath, getPage } from '@invitae/nucleobase-engine-contentful';
import { removeDataAnalyticsAttrOnBodyTag } from './removeDataAnalyticsAttrOnBodyTag/removeDataAnalyticsAttrOnBodyTag.esm.js';
import { setDataAnalyticsAttrOnBodyTag } from './setDataAnalyticsAttrOnBodyTag/setDataAnalyticsAttrOnBodyTag.esm.js';

var usePageAudience = function (_a) {
    var page = _a.page, path = _a.path, _b = _a.usePreviewClient, usePreviewClient = _b === void 0 ? false : _b, _c = _a.contentfulClientCredentials, contentfulClientCredentials = _c === void 0 ? undefined : _c;
    var contentfulClientCredentialsFromContext = useContext(ContentfulClientConfigContext);
    var loadContentfulPage = useCallback(function (path) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, countryCode, page;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!contentfulClientCredentialsFromContext ||
                        (!contentfulClientCredentialsFromContext && !contentfulClientCredentials))
                        return [2 /*return*/];
                    _a = __read(countryCodeIndicatorFromPath(path), 1), countryCode = _a[0];
                    return [4 /*yield*/, getPage({
                            contentfulClientCredentials: contentfulClientCredentialsFromContext,
                            countryCode: countryCode,
                            path: path,
                            usePreviewClient: usePreviewClient,
                        })];
                case 1:
                    page = _b.sent();
                    if (!page) {
                        removeDataAnalyticsAttrOnBodyTag();
                        return [2 /*return*/];
                    }
                    setDataAnalyticsAttrOnBodyTag(page);
                    return [2 /*return*/];
            }
        });
    }); }, [contentfulClientCredentials, path]);
    useEffect(function () {
        if (page) {
            setDataAnalyticsAttrOnBodyTag(page);
            return;
        }
        if (path && !page) {
            loadContentfulPage(path);
            return;
        }
    }, [page, path, contentfulClientCredentials, usePreviewClient]);
};

export { usePageAudience };
//# sourceMappingURL=usePageAudience.esm.js.map
